import { render } from "./FilterKuartal.vue?vue&type=template&id=574ac881"
import script from "./FilterKuartal.vue?vue&type=script&lang=js"
export * from "./FilterKuartal.vue?vue&type=script&lang=js"
script.render = render

export default script